var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnn = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V5H8V4H4Z",
    fill: "#606A76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V7H4V6H8Z",
    fill: "#606A76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5C9.77614 5 10 4.77614 10 4.5C10 4.22386 9.77614 4 9.5 4C9.22386 4 9 4.22386 9 4.5C9 4.77614 9.22386 5 9.5 5Z",
    fill: "#606A76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5C10 6.77614 9.77614 7 9.5 7C9.22386 7 9 6.77614 9 6.5C9 6.22386 9.22386 6 9.5 6C9.77614 6 10 6.22386 10 6.5Z",
    fill: "#606A76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1L5 0L4 1L3 0L2 1V8H0V10C0 11.1046 0.89543 12 2 12H10.5L10.4696 11.9798C10.6805 11.9587 10.878 11.9183 11.0558 11.8459C11.3945 11.7079 11.6291 11.4681 11.7721 11.1345C11.9017 10.8319 11.9516 10.4621 11.9757 10.0528C12 9.63965 12 9.12757 12 8.5148V1L11 0L10 1L9 0L8 1L7 0L6 1ZM9.02258 9.99408C9.0002 9.61368 9 9.13067 9 8.5V8H3V2H11V8.5C11 9.13067 10.9998 9.61368 10.9774 9.99408C10.9546 10.3817 10.9108 10.6056 10.8529 10.7405C10.8084 10.8444 10.7617 10.8859 10.6785 10.9198C10.5615 10.9674 10.3617 11 10 11C9.63832 11 9.43846 10.9674 9.32146 10.9198C9.23825 10.8859 9.19161 10.8444 9.14707 10.7405C9.08923 10.6056 9.04537 10.3817 9.02258 9.99408ZM8 9H1V10C1 10.5523 1.44772 11 2 11H8V9Z",
    fill: "#606A76"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ann.d1ee0022fc817d97237bdca09f6b2148.svg";